import { i18n } from '@shared/i18n';
import { GenericModel } from '@shared/model/generic-model';
import StringField from '@shared/fields/string-field';
import DecimalField from '@shared/fields/decimal-field';
import BooleanField from '@shared/fields/boolean-field';
import EnumeratorField from '@shared/fields/enumerator-field';

function label(name) {
    return i18n(`entities.subprogram.fields.payment.${name}`);
}

function enumeratorLabel(name, value) {
    return i18n(`entities.subprogram.enumerators.payment.${name}.${value}`);
}

const fields = {
    exist: new BooleanField('exist', label('exist'), { required: true }),
    price: new DecimalField('price', label('price'), {
        "required": true,
        "min": 1,
    }),
    defaultCurrency: new StringField('defaultCurrency', label('defaultCurrency'), { required: true }),
    type: new EnumeratorField('type', label('type'), [
        { id: 'standard', label: enumeratorLabel('type', 'standard') },
    ], { "required": true }),
    externalAccount: new StringField('externalAccount', label('externalAccount'), {}),
}

export class SubprogramPaymentModel extends GenericModel {
    static get fields() {
        return fields;
    }
}